import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/client";
import { ENDPOINTS } from "@/api/endpoints";

export const useReassignTenantsMutation = () => {
  return useMutation({
    mutationFn: ({
      jobId,
      tenantIds,
    }: {
      jobId: string;
      tenantIds: string[];
    }) =>
      apiClient.post(ENDPOINTS.REASSIGN_TENANTS(jobId), {
        json: {
          tenantIds: tenantIds,
        },
      }),
  });
};
